import { getCommandNumberService, masterControl } from "../../services";
import { masterControlPayload } from "../payloads/masterControlPayload";

export const backendDispatches = (
  MCControlName,
  program,
  machineIds,
  temp,
  data,
  swt
) => {
  let payload;
  try {
    payload = masterControlPayload(program, {
      temp,
      data,
      deviceType: swt,
    });
  } catch (error) {
    return Promise.reject(error);
  }
  if (!payload) {
    return Promise.resolve();
  }

  return getCommandNumberService(MCControlName).then((commandNumber) =>
    masterControl(swt, machineIds, {
      commandNumber,
      actionType: MCControlName,
      ...payload,
    })
  );
};
